import {
  datasetApiSlice,
  useGetCohortAttritionByCohortProfileIdQuery,
  useLazyGetCohortAttritionByCohortProfileIdQuery,
} from './cohortAttritionSlice';

const upsertCohortAttritionQueryData = datasetApiSlice.util.upsertQueryData;

export {
  datasetApiSlice,
  useGetCohortAttritionByCohortProfileIdQuery,
  useLazyGetCohortAttritionByCohortProfileIdQuery,
  upsertCohortAttritionQueryData,
};
